module.exports = __webpack_public_path__ + "img/tips-ts.98729b72.svg";